import { createAction } from 'redux-actions';

export const setDisplay = createAction('SET_DISPLAY');

export default {
  setDisplay,
};
